import { ReactNode, CSSProperties } from 'react';

export interface KbdClusterItem {
  k: ReactNode;
  l: ReactNode;
}

export interface KbdClusterProps {
  items: KbdClusterItem[];
  style?: CSSProperties;
  className?: string;
}

export function KbdCluster({ items, style, className = '' }: KbdClusterProps) {
  return (
    <div className={`ds-kbd-cluster ${className}`.trim()} style={style}>
      {items.map((it, i) => (
        <span key={i}>
          <span className="ds-kbd">{it.k}</span> {it.l}
        </span>
      ))}
    </div>
  );
}

export default KbdCluster;
